import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "../../shared/Icon";
import QuizAnswerChoice from "./QuizAnswerChoice";
import QuizCardResultText from "./QuizCardResultText";
import { QUIZ_ANSWER_STATES, QUIZ_RESULT_STATES } from "../constants";

const propTypes = {
  answerOptions: PropTypes.arrayOf(
    PropTypes.shape({
      answerLetter: PropTypes.string,
      answerText: PropTypes.string.isRequired,
      link: PropTypes.string,
      state: PropTypes.oneOf(Object.values(QUIZ_ANSWER_STATES)).isRequired
    })
  ).isRequired,
  cardState: PropTypes.oneOf(Object.values(QUIZ_RESULT_STATES)).isRequired,
  questionId: PropTypes.number.isRequired,
  questionIndex: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired
};

const defaultProps = {};
function QuizCardResult({
  cardState,
  answerOptions,
  questionId,
  questionIndex,
  questionText
}) {
  const [bannerExpanded, setBannerExpanded] = useState(true);

  const toggleBanner = () => {
    setBannerExpanded(!bannerExpanded);
  };

  return (
    <div
      className={`quiz-card-result ${cardState}`}
      data-testid={`QuizCardResult-${questionId}`}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        onClick={toggleBanner}
        className={`banner ${
          bannerExpanded ? "expanded" : "collapsed"
        } ${cardState}`}
      >
        <h5 className="question-container">
          <span className="question-index">{questionIndex}. </span>
          <span dangerouslySetInnerHTML={{ __html: questionText }} />
        </h5>
        <div className="icon-container">
          <Icon size="sm" name={bannerExpanded ? "up" : "down-48"} />
        </div>
      </div>
      {bannerExpanded && (
        <div className={`answer-container ${cardState}`}>
          <QuizCardResultText cardState={cardState} />
          <div className="answer-columns">
            {answerOptions.map((answerOption) => {
              return (
                <div key={answerOption.answerLetter} className="answer-column">
                  <QuizAnswerChoice
                    link={answerOption.link}
                    isSelectedAnswer={false}
                    answerLetter={answerOption.answerLetter}
                    answerText={answerOption.answerText}
                    state={answerOption.state}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

QuizCardResult.propTypes = propTypes;
QuizCardResult.defaultProps = defaultProps;

export default QuizCardResult;
